module.exports = __webpack_public_path__ + "static/media/bmw.70d18c92.png";